import { renderless, api } from "@opentiny/vue-renderless/dropdown-menu/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import { iconUp, iconDown, iconUnfilter, iconSort, iconDeltaDown, iconDeltaUp } from "@opentiny/vue-icon";
import Clickoutside from "@opentiny/vue-renderless/common/deps/clickoutside";
import "@opentiny/vue-theme-mobile/dropdown-menu/index.css";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  props: [].concat(props, ["activeColor", "closeOnClickOutside", "closeOnClickOverlay", "direction", "duration", "overlay", "zIndex"]),
  components: {
    IconUp: iconUp(),
    IconDown: iconDown(),
    IconUnfilter: iconUnfilter(),
    IconSort: iconSort(),
    IconDeltaDown: iconDeltaDown(),
    IconDeltaUp: iconDeltaUp()
  },
  directives: {
    Clickoutside
  },
  emits: ["open"],
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    ref: "menu",
    staticClass: "tiny-mobile-dropdown-menu"
  }, [_c("div", {
    staticClass: "tiny-mobile-dropdown-menu__bar tiny-mobile-dropdown-menu__bar--opened"
  }, _vm._l(_vm.state.children, function(item, index) {
    return _c("div", {
      directives: [{
        name: "clickoutside",
        rawName: "v-clickoutside",
        value: _vm.clickOutside,
        expression: "clickOutside"
      }],
      key: index,
      staticClass: "tiny-mobile-dropdown-menu__item",
      class: [item.disabled ? "is-disabled" : "", item.titleClass],
      attrs: {
        "role": "button",
        "tabindex": item.disabled ? -1 : 0
      },
      on: {
        "click": function click($event) {
          return _vm.toggleItem(index, item);
        }
      }
    }, [_c("div", {
      staticClass: "tiny-mobile-dropdown-menu__title",
      class: {
        "is-active": item.state.showPopup,
        "is-down": item.state.showPopup === (_vm.direction === "down")
      },
      style: {
        color: item.state.showPopup ? _vm.activeColor : ""
      }
    }, [_c("div", {
      staticClass: "tiny-mobile-dropdown-menu__title-wrap"
    }, [!_vm.slots.title ? _c("span", [_c("span", {
      staticClass: "tiny-mobile-dropdown-menu__title-text"
    }, [_vm._v(_vm._s(item.state.displayTitle))]), item.type === "sort" ? _c("span", {
      staticClass: "tiny-mobile-dropdown-menu__title-icon"
    }, [_c("icon-delta-up", {
      staticClass: "up",
      attrs: {
        "fill": item.state.sort === "asc" ? _vm.activeColor ? _vm.activeColor : "#f36f64" : "#ccc"
      }
    }), _c("icon-delta-down", {
      staticClass: "down",
      attrs: {
        "fill": item.state.sort === "desc" ? _vm.activeColor ? _vm.activeColor : "#f36f64" : "#ccc"
      }
    })], 1) : _c(item.type === "filter" ? "IconUnfilter" : item.type === "selection" && item.state.showPopup ? "IconUp" : "IconDown", {
      tag: "component",
      class: [item.type === "filter" ? "filter-icon" : ""],
      attrs: {
        "fill": item.state.showPopup ? _vm.activeColor ? _vm.activeColor : "#f36f64" : "#ccc"
      }
    })], 1) : _vm._t("title")], 2)])]);
  }), 0), _vm._t("default")], 2);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobile = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobile as default
};
